export default [
  {
    path: '/main/models',
    meta: {
      tag: 'list_model',
      name: 'Modelos',
      breadcrumb: 'Modelos'
    },
    component: () => import(/* webpackChunkName: "models-list" */ '@/views/main/settings/stock-registers/models/Index.vue'),
    children: [
      {
        path: '',
        name: 'listmodels',
        meta: {
          tag: 'list_model',
          menu: 'settings',
          name: 'Modelos'
        },
        component: () => import(/* webpackChunkName: "models-list" */ '@/views/main/settings/stock-registers/models/List.vue')
      },
      {
        path: '/main/model/add',
        name: 'addmodel',
        meta: {
          tag: 'add_model',
          menu: 'settings',
          name: 'Adicionar | Modelo',
          breadcrumb: 'Adicionar Modelo'
        },
        component: () => import(/* webpackChunkName: "model-add" */ '@/views/main/settings/stock-registers/models/Add.vue')
      },
      {
        path: '/main/model/:id',
        name: 'editmodel',
        meta: {
          tag: 'edit_model',
          menu: 'settings',
          name: 'Editar | Modelo',
          breadcrumb: 'Editar Modelo'
        },
        component: () => import(/* webpackChunkName: "model-edit" */ '@/views/main/settings/stock-registers/models/Edit.vue')
      }
    ]
  },
]
